import { Routes, Route } from "react-router-dom";
import { cfmnavigationLinks } from "../data/navData";
import DashboardLayout from "../layout/DashboardLayout/DashboardLayout";
import CfmHome from "../pages/cfmPages/CfmHome";
import CfmUser from "../pages/cfmPages/CfmUser";
import CfmFeedback from "../pages/FeedbackReport2";
import Calendar from "../components/Calendar/Calendar";
import CalendarOverview from "../components/Calendar/CalendarOverview";
import Account from "../components/Account/Account";
import ProtectedRoute from "./ProtectedRoute";
import VendorManagement from "../pages/cfmPages/CfmVendors";
import CfmAttendance from "../pages/cfmPages/CfmAttendance";
import CfmAttendanceRecords from "../pages/cfmPages/CfmAttendanceRecords";
import CfmLeaveRecords from "../pages/cfmPages/CfmLeaveRecords";
import CfmApplyLeave from "../pages/cfmPages/CfmApplyLeave";
import CfmEmployeeLeaveRequests from "../pages/cfmPages/CfmEmployeeLeaveRequests";
import CfmEmployeeAttendance from "../pages/cfmPages/CfmEmployeeAttendance";
import CreateCalendar from "../pages/adminPages/CreateCalendar";
import AttendanceRecordDetail from "../pages/attendance/AttendanceRecordDetail";
import UserDetails from "../pages/UserDetails";
import CfmEmployeeManualLeave from "../pages/cfmPages/CfmEmployeeManualLeave";

const CfmRoutes = () => {
  return (
    <DashboardLayout
      navigationLinks={cfmnavigationLinks}
      roleBasePath="cfm"
      useApiLogout={true}
    >
      <Routes>
        {/* CFM Routes - Relative paths under /cfm/* */}
        <Route
          path=""
          element={<ProtectedRoute element={<CfmHome />} requiredRole="cfm" />}
        />
        <Route
          path="attendance/record/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordDetail />}
              requiredRole="cfm"
            />
          }
        />
        <Route
          path="users"
          element={<ProtectedRoute element={<CfmUser />} requiredRole="cfm" />}
        />
        <Route
          path="users/:email"
          element={<ProtectedRoute element={<UserDetails />} requiredRole="cfm" />}
        />
        <Route
          path="vendor"
          element={
            <ProtectedRoute element={<VendorManagement />} requiredRole="cfm" />
          }
        />
        <Route
          path="feedback"
          element={
            <ProtectedRoute element={<CfmFeedback />} requiredRole="cfm" />
          }
        />
        <Route
          path="calendar"
          element={
            <ProtectedRoute element={<CalendarOverview />} requiredRole="cfm" />
          }
        />
        <Route
          path="calendar/create"
          element={
            <ProtectedRoute element={<CreateCalendar />} requiredRole="cfm" />
          }
        />
        <Route
          path="calendar/:year"
          element={<ProtectedRoute element={<Calendar />} requiredRole="cfm" />}
        />
        <Route
          path="account"
          element={<ProtectedRoute element={<Account />} requiredRole="cfm" />}
        />
        <Route
          path="vendor"
          element={
            <ProtectedRoute element={<VendorManagement />} requiredRole="cfm" />
          }
        />
        <Route
          path="attendance"
          element={
            <ProtectedRoute element={<CfmAttendance />} requiredRole="cfm" />
          }
        />
        <Route
          path="attendance/record"
          element={
            <ProtectedRoute
              element={<CfmAttendanceRecords />}
              requiredRole="cfm"
            />
          }
        />
        <Route
          path="attendance/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordDetail />}
              requiredRole="cfm"
            />
          }
        />
        <Route
          path="attendance/leave-records"
          element={
            <ProtectedRoute element={<CfmLeaveRecords />} requiredRole="cfm" />
          }
        />
        <Route
          path="attendance/apply-leave"
          element={
            <ProtectedRoute element={<CfmApplyLeave />} requiredRole="cfm" />
          }
        />
        <Route
          path="attendance/employee-manual-leave"
          element={
            <ProtectedRoute
              element={<CfmEmployeeManualLeave />}
              requiredRole="cfm"
            />
          }
        />
        <Route
          path="attendance/employee-leave-requests"
          element={
            <ProtectedRoute
              element={<CfmEmployeeLeaveRequests />}
              requiredRole="cfm"
            />
          }
        />
        <Route
          path="attendance/employee-attendance"
          element={
            <ProtectedRoute
              element={<CfmEmployeeAttendance />}
              requiredRole="cfm"
            />
          }
        />

        {/* 404 Page */}
        <Route path="*" element={<h1>404 - Page Not Found</h1>} />
      </Routes>
    </DashboardLayout>
  );
};

export default CfmRoutes;
